import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
const ConnectionStatus = () => {
  const {
    t
  } = useTranslation();
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  useEffect(() => {
    const updateOnlineStatus = () => setIsOnline(navigator.onLine);
    window.addEventListener("online", updateOnlineStatus);
    window.addEventListener("offline", updateOnlineStatus);
    return () => {
      window.removeEventListener("online", updateOnlineStatus);
      window.removeEventListener("offline", updateOnlineStatus);
    };
  }, []);
  if (!isOnline) {
    return <div style={modalStyle}>
        <div style={spinnerStyle}></div>
        <p>{t("ui.components.conectionStatus.problemasDeConexao")}</p>
        <p>{t("ui.components.conectionStatus.porFavorVerificaATuaConexao")}</p>
        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
        </style>
      </div>;
  }
  return null;
};
const modalStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  backgroundColor: "rgba(0, 0, 0, 0.85)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  color: "#fff",
  zIndex: 9999
};
const spinnerStyle = {
  width: "60px",
  height: "60px",
  border: "8px solid #f3f3f3",
  borderTop: "8px solid #EE754C",
  borderRadius: "50%",
  animation: "spin 1s linear infinite",
  marginBottom: "15px"
};
export const useOnlineStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  useEffect(() => {
    const updateOnlineStatus = () => setIsOnline(navigator.onLine);
    window.addEventListener("online", updateOnlineStatus);
    window.addEventListener("offline", updateOnlineStatus);
    return () => {
      window.removeEventListener("online", updateOnlineStatus);
      window.removeEventListener("offline", updateOnlineStatus);
    };
  }, []);
  return isOnline;
};
export default ConnectionStatus;
